import { render, staticRenderFns } from "./YButton.vue?vue&type=template&id=3bae78ed&scoped=true"
import script from "./YButton.vue?vue&type=script&lang=js"
export * from "./YButton.vue?vue&type=script&lang=js"
import style0 from "./YButton.vue?vue&type=style&index=0&id=3bae78ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bae78ed",
  null
  
)

export default component.exports